import { render, staticRenderFns } from "./loginV2.optimized.vue?vue&type=template&id=3b379496"
import script from "./loginV2.optimized.vue?vue&type=script&lang=js"
export * from "./loginV2.optimized.vue?vue&type=script&lang=js"
import style0 from "./loginV2.optimized.vue?vue&type=style&index=0&id=3b379496&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports